document.addEventListener('DOMContentLoaded', function() {
    const faqTitles = document.querySelectorAll('.faq__item .faq__title');

    faqTitles.forEach((title) => {
        const item = title.closest('.faq__item');
        if (!item || item.dataset.faqBound === 'true') {
            return;
        }

        item.dataset.faqBound = 'true';
        title.addEventListener('click', function() {
            item.classList.toggle('active');
        });
    });
});